export default __webpack_public_path__ + "static/media/helpCenterWheel.6c4eca5b.svg";